import React, { useState } from "react";
import { Link } from "react-router-dom";
// import { logout } from '../../../actions/userActions';
import { useDispatch, useSelector } from "react-redux";
import ReceiveAmount from "../Customer/ReceiveAmount";
import RentOutModal from "../Order/RentOutModal";
import ReturnModal from "../Order/ReturnModal";

export default function SideBar() {
  const dispatch = useDispatch();
  // const logoutHandler = () => {
  //   dispatch(logout());
  // };
  const [modalIsOpen, setIsOpen] = useState(false);
  const [activePage, setActivePage] = useState("Home");
  function openModalRentOut() {
    setIsOpen(true);
  }
  return (
    <>
      <div class="theme-setting-wrapper">
        <div id="settings-trigger">
          <i class="ti-settings"></i>
        </div>
        <div id="theme-settings" class="settings-panel">
          <i class="settings-close ti-close"></i>
          <p class="settings-heading">SIDEBAR SKINS</p>
          <div class="sidebar-bg-options selected" id="sidebar-light-theme">
            <div class="img-ss rounded-circle bg-light border mr-3"></div>Light
          </div>
          <div class="sidebar-bg-options" id="sidebar-dark-theme">
            <div class="img-ss rounded-circle bg-dark border mr-3"></div>Dark
          </div>
          <p class="settings-heading mt-2">HEADER SKINS</p>
          <div class="color-tiles mx-0 px-4">
            <div class="tiles success"></div>
            <div class="tiles warning"></div>
            <div class="tiles danger"></div>
            <div class="tiles info"></div>
            <div class="tiles dark"></div>
            <div class="tiles default"></div>
          </div>
        </div>
      </div>

      <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">
          <li
            class={activePage === "Home" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("Home")}
          >
            <Link class="nav-link" to="/">
              <i class="icon-grid menu-icon"></i>
              <span class="menu-title">Dashboard</span>
            </Link>
          </li>
          <li
            class={activePage === "pending" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("pending")}
          >
            <Link class="nav-link" to="/pending/view">
              <i class="icon-grid menu-icon"></i>
              <span class="menu-title">KYC Approval</span>
            </Link>
          </li>
          <li
            class={
              activePage === "order-cancellations"
                ? `nav-item active`
                : "nav-item"
            }
            onClick={() => setActivePage("pending")}
          >
            <Link class="nav-link" to="/order-cancellations">
              <i class="icon-grid menu-icon"></i>
              <span class="menu-title">Order Cancel</span>
            </Link>
          </li>

          <li
            class={activePage === "orderApprovals" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("orderApprovals")}
          >
            <Link class="nav-link" to="/order-approvals" aria-expanded="false">
              <i class="icon-layout menu-icon"></i>
              <span class="menu-title">Order Approvals</span>
            </Link>
          </li>

          <li
            class={activePage === "Package" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("Package")}
          >
            <Link class="nav-link" to="/package/view">
              <i class="icon-grid menu-icon"></i>
              <span class="menu-title">Package</span>
            </Link>
          </li>

          <li
            class={activePage === "category" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("category")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/categories"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i class="icon-layout menu-icon"></i>
              <span class="menu-title">Category</span>
            </Link>
          </li>
          <li
            class={activePage === "brand" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("brand")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/brands"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i class="icon-layout menu-icon"></i>
              <span class="menu-title">Brands</span>
            </Link>
          </li>

          <li
            class={activePage === "user" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("user")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/users"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i class="icon-grid-2 menu-icon"></i>
              <span class="menu-title">Customer</span>
            </Link>
          </li>

          <li
            class={activePage === "orders" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("orders")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/orders"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i class="icon-layout menu-icon"></i>
              <span class="menu-title">Orders</span>
            </Link>
          </li>

          <li
            class={activePage === "new-order" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("new-order")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/order/new"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i class="icon-contract menu-icon"></i>
              <span class="menu-title">New Orders</span>
            </Link>
          </li>
           <li
            class={activePage === "expired-orders" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("expired-orders")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/expired-orders"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i class="icon-layout menu-icon"></i>
              <span class="menu-title">Expired Orders</span>
            </Link>
          </li>


          <li
            class={
              activePage === "availability" ? `nav-item active` : "nav-item"
            }
            onClick={() => setActivePage("availability")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/order/search"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i class="icon-contract menu-icon"></i>
              <span class="menu-title">Availability</span>
            </Link>
          </li>

          <li
            class={activePage === "product" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("product")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/products"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i class="icon-grid-2 menu-icon"></i>
              <span class="menu-title">Product</span>
            </Link>
          </li>

          <li
            class={activePage === "Itemcode" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("Itemcode")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/itemcode"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i class="icon-grid-2 menu-icon"></i>
              <span class="menu-title">Items</span>
            </Link>
          </li>

          <li
            class={
              activePage === "not-delivered-list"
                ? `nav-item active`
                : "nav-item"
            }
            onClick={() => setActivePage("not-delivered-list")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/not-delivery"
              aria-expanded="false"
              aria-controls="charts"
            >
              <i class="icon-bar-graph menu-icon"></i>
              <span class="menu-title">Rent out Pending</span>
            </Link>{" "}
          </li>
          <li
            class={
              activePage === "not-return-list" ? `nav-item active` : "nav-item"
            }
            onClick={() => setActivePage("not-return-list")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/not-return"
              aria-expanded="false"
              aria-controls="charts"
            >
              <i class="icon-bar-graph menu-icon"></i>
              <span class="menu-title">Return Pending</span>
            </Link>{" "}
          </li>
          <li
            class={activePage === "receive" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("receive")}
            data-toggle="modal"
            data-target="#exampleModal"
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              aria-expanded="false"
              aria-controls="charts"
            >
              <i class="icon-contract menu-icon"></i>
              <span class="menu-title">Payment</span>
            </Link>
          </li>

          <li
            class={activePage === "rent-out" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("rent-out")}
          >
            <Link
              class="nav-link"
              data-toggle="collapse"
              to="/rent-out"
              aria-expanded="false"
              aria-controls="charts"
            >
              <i class="icon-bar-graph menu-icon"></i>
              <span class="menu-title">Rent Out</span>
            </Link>{" "}
          </li>

          <li class={activePage === "return" ? `nav-item active` : "nav-item"}>
            <Link
              class="nav-link"
              data-toggle="collapse"
              aria-expanded="false"
              aria-controls="charts"
              to="/return"
            >
              <i class="icon-contract menu-icon"></i>
              <span class="menu-title">Return</span>
            </Link>{" "}
          </li>
          <li
            class={activePage === "report" ? `nav-item active` : "nav-item"}
            onClick={() => setActivePage("report")}
          >
            <Link class="nav-link" to="/report" aria-expanded="false">
              <i class="icon-bar-graph menu-icon"></i>
              <span class="menu-title">Report</span>
            </Link>
          </li>
        </ul>
      </nav>
      <ReceiveAmount />
      <RentOutModal />
      <ReturnModal />
    </>
  );
}
